import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { ControlValueAccessor } from '@ngneat/reactive-forms';

import {
  SectionedDropdownItem,
  DropdownItem,
} from '@digital-platform/rs-frontend/domain';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  selector: 'digital-platform-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DropdownComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: DropdownComponent,
    },
  ],
})
export class DropdownComponent
  implements ControlValueAccessor, Validator, AfterViewInit
{
  @Input() control?: AbstractControl;
  @Input() variant = 'base';
  @Input() placeholder = '';
  @Input() name = '';
  @Input() value = '';
  @Input() id = '';
  @Input() required = false;
  @Input() disabled = false;
  @Input() invalid = false;
  @Input() errorMessage = '';
  @Input() options?: DropdownItem[] = [];
  @Input() sectionedOptions?: SectionedDropdownItem[] = [];
  public opened = false;
  public hovered = false;
  public sectionedOptionsLength = 0;

  ngOnInit() {
    // Sync the disabled values
    if (this.disabled) {
      this.control?.disable();
    } else if (this.control?.disabled) {
      this.disabled = true;
    }

    // Sync the invalid values
    if (this.invalid) {
      this.control?.markAsTouched();
      this.control?.setErrors({
        invalid: true,
      });
    } else if (this.control?.invalid) {
      this.invalid = true;
    }
  }

  public onChange = (_value: string) => {};

  ngAfterViewInit(): void {
    if (this.sectionedOptions) {
      this.sectionedOptions.forEach((childObject) => {
        this.sectionedOptionsLength += childObject.list.length;
      });
    }
  }

  onTouched = () => {
    this.markAsTouched();
  };

  writeValue(value: string) {
    if (value) {
      this.markAsTouched();
      this.value = value;
      this.onChange(value);
    } else {
      this.value = '';
    }
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  setValue(event: any) {
    this.markAsTouched();
    if (!this.control?.disabled) {
      this.value = event.target.value;
      this.onChange(this.value);
    }
  }

  markAsTouched() {
    if (this.control && !this.control?.touched) {
      this.control.markAsTouched();
    }
  }

  onBlur(): void {
    this.markAsTouched();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }

  isTouchedAndInvalid(): boolean | undefined {
    return this.control?.touched && this.control?.invalid;
  }

  public focusEvent() {
    this.opened = !this.opened;
  }

  public blurEvent() {
    this.markAsTouched();
    this.opened = false;
  }

  public selectOption(option: DropdownItem) {
    this.markAsTouched();

    if (!this.control?.disabled) {
      this.value = option.text;
      this.onChange(option.text);
      setTimeout(() => {
        this.opened = false;
      }, 10);
    }
  }
}
